module.exports = __webpack_public_path__ + "static/media/cam.165ac511.png";